import { useChatContext, UNSENT_FILE_ID } from "@/services/chat-provider"
import ChatFileCard from "../chat-content/ChatFileCard"

/** @param {{messageFile ?: ChatMessage["file"]}} props */
export default function ChatBubbleFileCard({ messageFile }) {
  const { useActiveChatSession } = useChatContext()

  const { data: activeChatSession } = useActiveChatSession()
  if(messageFile == null) return null

  const fileObj = (() => {
    if(typeof messageFile === "object") return messageFile

    if(activeChatSession?.files == null) return null
    if(activeChatSession.files.length === 0) return null
    if(messageFile === UNSENT_FILE_ID) {
      return activeChatSession.files[activeChatSession.files.length - 1]
    }
    return activeChatSession.files.find(file => file._id === messageFile)
  })();

  if(fileObj == null) return null

  return (
    <div className="chat-bubble__file-card-wrapper">
      <ChatFileCard>
        <ChatFileCard.Icon />
        <ChatFileCard.Name>{fileObj.name}</ChatFileCard.Name>
      </ChatFileCard>
    </div>
  )
}